<section id="ai-assist-manager">
  <app-hamburger-wrapper></app-hamburger-wrapper>
  <app-manager-header [title]="'Kyloe AI NoteTaker Manager'"></app-manager-header>

  @if (clientConfig?.notetakerEnabled) {
    <section class="content scroll-container">
      <article>

        <h2 class="heading-underline">Calls from {{ corpIdDisplay }}
          <span class="clear-input">
            <input class="search-profiles" type="text" placeholder="Search all calls..." autofocus
                   (input)="filterCalls($event)" [(ngModel)]="searchText" #searchInput>
            <i [ngClass]="searchText ? 'bhi-times' : 'bhi-search'" class="clear-icon" (click)="clearSearchField()"
               [title]="searchText ? 'Clear' : ''" #clearSearch></i>
          </span>
          <span class="billing-period-stats sub-info">
            <ul class="stats-display">
              <li class="stat-item">Billing Period Stats</li>
              <li class="date-picker-container stat-item">
                <mat-icon fontIcon="calendar_month" class="material-icons-outlined"></mat-icon>
                <div class="divider"></div>
                <mat-select class="date-picker-container" [formControl]="billingPeriodControl"
                            (selectionChange)="setMonthAndYear($event)">
                  @for (billingPeriod of billingPeriods; track $index; let i = $index) {
                    <mat-option [value]="billingPeriod.label">
                      <span class="label-text">{{ billingPeriod.label }}</span>
                      @if (billingPeriod.period) {
                        <span class="period-text">{{ billingPeriod.period }}</span>
                      }
                    </mat-option>
                  }

              </mat-select>
              </li>

            </ul>
            <ul class="stats-display">
              <li class="stat-item">
                <mat-icon fontIcon="timer" class="material-icons-outlined stat-result-icon"
                [matTooltip]="formattedDuration"
                matTooltipShowDelay="500"></mat-icon>
              </li>
              <li class="stat-item hide-text">
                {{ formattedDuration }}
              </li>
              <li class="stat-item">
                <mat-icon class="stat-result-icon"
                [matTooltip]="totalCalls + ' calls'"
                matTooltipShowDelay="500">call</mat-icon>
              </li>
              <li class="stat-item hide-text">
                {{ totalCalls }} calls
              </li>
            </ul>

            <span id="integrationPage">
              <mat-icon (click)="openNoteTakerGlobalSettings()"
                        fontIcon="settings"
                        matTooltip="Global Note Taker Intergration Settings"
                        matTooltipShowDelay="500"></mat-icon>
            </span>
          </span>

        </h2>

        <section class="scrollable-container">
          <div>
            <table mat-table [dataSource]="filteredCallsDataSource" matSort class="table-striped">

              <ng-container matColumnDef="callTitle">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-notetaker-manager"> Call title</th>
                <td mat-cell *matCellDef="let element" class="table-notetaker-manager"> {{ element.callTitle }}</td>
              </ng-container>

              <ng-container matColumnDef="timeDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Time and date</th>
                <td mat-cell *matCellDef="let element"> {{ element.formattedTimeDate }}</td>
              </ng-container>

              <ng-container matColumnDef="attendeeEmail">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> External participants</th>
                <td mat-cell *matCellDef="let element"> {{ element.attendeeEmails }}</td>
              </ng-container>

              <ng-container matColumnDef="callerId">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Caller</th>
                <td mat-cell *matCellDef="let element"> {{ element.callerId }}</td>
              </ng-container>

              <ng-container matColumnDef="bhEntityIds">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> BH entity ID(s)</th>
                <td mat-cell *matCellDef="let element"> {{ element.bhEntityIds }}</td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="callsDisplayedColumns" matSort></tr>
              <tr mat-row *matRowDef="let row; columns: callsDisplayedColumns;"></tr>
            </table>
          </div>
        </section>
      </article>
    </section>
  }
  <div id="version-number" [ngClass]="{'expand-version': expandVersion}" title="Double click to copy -
                  {{environment.environmentIdentifier}} v{{appVersion}}"
      (dblclick)="copyToClipboard(environment.environmentIdentifier + ' v' + appVersion)">
      @if (environment.environmentIdentifier !== 'PROD') {
        ENV: {{ environment.environmentIdentifier }}
      }
      v{{ appVersion }}
    </div>
  </section>
